import { render, staticRenderFns } from "./pushPage.vue?vue&type=template&id=67118cfa&scoped=true&"
import script from "./pushPage.vue?vue&type=script&lang=js&"
export * from "./pushPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67118cfa",
  null
  
)

export default component.exports